import styled from 'styled-components';
import { Typography } from '../../../../../stories/atoms';
import { Colors } from '../../../../../theme';

export const StyledThresholdText = styled(Typography)<{ shadeColor: Colors }>`
  color: ${({ theme: { color }, shadeColor }) => {
    return color[shadeColor];
  }};
`;

export const StyledUppercaseText = styled(Typography)`
  text-transform: uppercase;
`;
